import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contest-leaderboard-details',
  templateUrl: './contest-leaderboard-details.component.html',
  styleUrls: ['./contest-leaderboard-details.component.scss']
})
export class ContestLeaderboardDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
